// import { useSelector } from "react-redux";
export default (modul, value) => {
  // const session = useSelector(state => state.session);
  const session = JSON.parse(localStorage.getItem('user'));
  // console.log("wowowoow", session.hak_akses);
  // return true;
  if (session) {
    if (session.hak_akses && session.hak_akses.length > 0) {
      const akses = session.hak_akses.filter(
        (row) => row.modul && row.modul.toUpperCase() === modul.toUpperCase()
      );
      if (akses.length > 0) {
        const hasAkses = akses.some((a) => parseInt(a.jenis_akses) >= value);
        return hasAkses;
      }
      // Module not found in hak_akses — not configured yet, allow access
      return true;
    }
    // User logged in but no hak_akses data — allow access
    return true;
  }
  window.location.href = '/auth/login';
  return true;
};
